import api from '@/services/api';

export default function(router) {
	router.beforeEach(async (to, from, next) => {
		let store = router.app.$store;

		function proceed() {
			if (to.path === '/login' || to.path === '/recuperarsenha' || to.path === '/redefinirsenha') {
				next('/');
			} else {
				next();
			}
		}

		if (store.usuario) {
			proceed();
		} else {
			try {
				let usuario = (await api.fetchUsuario()).data;

				store.usuario = usuario;

				proceed();
			} catch (error) {
				if (to.meta.anonymous) {
					next();
				} else {
					next({
						path: '/login',
						query: { redirect: to.fullPath }
					});
				}
			}
		}
	});
}